<template>
  <!-- {{ dividend }} -->
  <tr class="table_roww" v-if="dividend">
    <td>
      {{ formateDateAndTime(dividend.date) }}
    </td>
    <td class="">
      <span
        :class="[
          dividend.action.toLowerCase() == 'sell' && 'text-red',
          dividend.action.toLowerCase() == 'swap' && 'text-orange',
          dividend.action.toLowerCase() == 'buy' && 'text-green-dark',
        ]"
        >{{ dividend.action }}</span
      >
    </td>
    <td v-if="dividend.coinFrom">
      <div class="td-with-image">
        <img
          v-if="dividend.coinFrom.iconUrl"
          style="border-radius: 100%; height: 20px"
          :src="dividend.coinFrom.iconUrl"
          alt=""
        />
        <span>{{ dividend.coinFrom.symbol }}</span>
      </div>
    </td>
    <td v-if="dividend.coinTo">
      <div class="td-with-image">
        <img
          v-if="dividend.coinTo.iconUrl"
          style="border-radius: 100%; height: 20px"
          :src="dividend.coinTo.iconUrl"
          alt=""
        />
        <span>{{ dividend.coinTo.symbol }}</span>
      </div>
    </td>
    <td>{{ formatAmount(dividend.amount) }}</td>
    <td>{{ formatAmount(dividend.price) }}</td>
    <td>{{ formatAmount(dividend.tradingFee) }}</td>
    <td>{{ formatAmount(dividend.totalAmount) }}</td>
    <td class="table-button">
      <button
        @click="goToTradeDetails(dividend)"
        class="relsify-button light-shade-green font-weight-light"
      >
        Details
      </button>
    </td>
  </tr>
</template>

<script>
import "@/mixins";
export default {
  props: ["dividend"],
  methods: {
    goToTradeDetails: function (dividend) {
      this.$router.push({
        name: "SingleTrade",
        query: { id: dividend.id },
      });
    },
  },
};
</script>

<style scoped>
.table_roww td {
  padding: 30px 10px;
  background: #fff;
}

.table_roww td p {
  display: inline;
  width: auto;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}
</style>
